<script setup>
import { $api } from '@/utils/api'
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

const route = useRoute()
const router = useRouter()
const form = ref(null)
const loading = ref(false)
const error = ref('')
const email = computed(() => String(route.query.email || ''))
const password = ref('')
const passwordConfirmation = ref('')
const passwordVisible = ref(false)

const submit = async () => {
  const result = await form.value?.validate()
  if (!result?.valid)
    return

  loading.value = true
  error.value = ''
  try {
    await $api('/api/auth/invitation/accept', {
      method: 'POST',
      body: {
        invitation_url: window.location.href,
        email: email.value,
        password: password.value,
        password_confirmation: passwordConfirmation.value,
      },
    })
    await router.replace({ name: 'login', query: { invitationAccepted: '1' } })
  }
  catch (err) {
    error.value = err?.data?.message ?? err?.response?._data?.message ?? 'Unable to accept this invitation.'
  }
  finally {
    loading.value = false
  }
}
</script>

<template>
  <VContainer class="fill-height d-flex align-center justify-center pa-4">
    <VCard
      max-width="480"
      width="100%"
      class="pa-2"
    >
      <VCardTitle class="text-h5 pt-5">
        Complete your account
      </VCardTitle>
      <VCardText>
        <p class="mb-6">
          Choose a password to activate your anaesthetist account.
        </p>
        <VAlert
          v-if="error"
          type="error"
          class="mb-4"
        >
          {{ error }}
        </VAlert>
        <VForm
          ref="form"
          @submit.prevent="submit"
        >
          <VTextField
            :model-value="email"
            label="Email"
            type="email"
            readonly
            class="mb-3"
          />
          <VTextField
            v-model="password"
            label="Password"
            :type="passwordVisible ? 'text' : 'password'"
            :append-inner-icon="passwordVisible ? 'ri-eye-off-line' : 'ri-eye-line'"
            :rules="[value => value.length >= 8 || 'Use at least 8 characters.']"
            class="mb-3"
            @click:append-inner="passwordVisible = !passwordVisible"
          />
          <VTextField
            v-model="passwordConfirmation"
            label="Confirm password"
            :type="passwordVisible ? 'text' : 'password'"
            :rules="[value => value === password || 'Passwords do not match.']"
          />
          <VBtn
            type="submit"
            color="primary"
            block
            :loading="loading"
            class="mt-4"
          >
            Activate account
          </VBtn>
        </VForm>
      </VCardText>
    </VCard>
  </VContainer>
</template>
